import { render, staticRenderFns } from "./ReviewDVIR.vue?vue&type=template&id=4478428e&scoped=true&"
import script from "./ReviewDVIR.vue?vue&type=script&lang=js&"
export * from "./ReviewDVIR.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDVIR.vue?vue&type=style&index=0&id=4478428e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4478428e",
  null
  
)

export default component.exports